import React from "react";
import { AlertTriangle, X } from "lucide-react";

const ITEMS = [
  { k: "name", label: "Name", detail: 'Does the generic name on the new bottle match the last one exactly?' },
  { k: "strength", label: "Strength", detail: "mg, mcg, or IU — read the numbers carefully." },
  { k: "imprint", label: "Imprint", detail: "Every letter and number on both sides of the pill." },
  { k: "manufacturer", label: "Manufacturer", detail: "Different manufacturers can make pills that look different." },
  { k: "directions", label: "Directions", detail: "How and when to take it — has anything changed?" },
  { k: "label", label: "Pharmacy label", detail: "Look for a change in dose, quantity, or prescriber notes." },
];

export default function RefillCompareDialog({ onClose }) {
  return (
    <div
      data-testid="refill-dialog"
      className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center px-4"
    >
      <div className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-xl">
        <div className="sticky top-0 bg-white border-b border-[#F0EFEA] px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 text-[#C26747]">
            <AlertTriangle size={18} />
            <span className="font-medium text-[#1C2B23]">My refill looks different</span>
          </div>
          <button
            data-testid="refill-close"
            type="button"
            onClick={onClose}
            className="text-[#5C6B62] hover:text-[#1C2B23]"
          >
            <X size={18} />
          </button>
        </div>

        <div className="p-6 space-y-5">
          <p className="text-sm text-[#1C2B23] leading-relaxed">
            Do <span className="font-medium">not</span> take a refill that looks different until you
            have compared these six things against your prior fill and the pharmacy label. When in
            doubt, call the dispensing pharmacist before taking a dose.
          </p>

          <ol className="space-y-3">
            {ITEMS.map((it, i) => (
              <li
                key={it.k}
                data-testid={`refill-item-${it.k}`}
                className="flex gap-3 items-start bg-[#F9F8F6] rounded-xl p-4"
              >
                <div className="font-mono-num w-7 h-7 rounded-full bg-[#E8F0EB] text-[#2B5339] font-semibold flex items-center justify-center text-sm flex-shrink-0">
                  {i + 1}
                </div>
                <div>
                  <div className="text-base font-medium text-[#1C2B23]">{it.label}</div>
                  <div className="text-sm text-[#5C6B62]">{it.detail}</div>
                </div>
              </li>
            ))}
          </ol>

          <div className="bg-[#FDF2ED] border border-[#F5C7B4] rounded-xl p-4 text-sm text-[#1C2B23]">
            <strong>Never</strong> confirm a pill&apos;s identity from a photograph. If anything is
            unclear, keep the pill separate and contact the dispensing pharmacist.
          </div>

          <button
            data-testid="refill-done"
            type="button"
            onClick={onClose}
            className="w-full bg-[#2B5339] text-white rounded-full py-3 text-sm font-medium hover:bg-[#1C2B23]"
          >
            I understand — close
          </button>
        </div>
      </div>
    </div>
  );
}
